import React, { useState, useEffect } from 'react';

import SentimentVeryDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentVeryDissatisfiedOutlined';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import SentimentNeutralOutlinedIcon from '@mui/icons-material/SentimentNeutralOutlined';
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';

import { ImageList, ImageListItem, ImageListItemBar } from '@mui/material';

function JobCardSatisfaction(props) {
  const emojiInfo = props.emojiInfo;
  const setEmoji = props.setEmoji;

  const [emojiValue, setEmojiValue] = useState(emojiInfo.satisfaction);

  const handleEmoji = (emojiVal) => {
    setEmojiValue(emojiVal);
    setEmoji(emojiVal);
  };

  useEffect(() => {
    let data = props.emojiInfo;
    setEmojiValue(data.satisfaction);
  }, [props.emojiInfo]);

  return (
    <ImageList cols={5} style={{ margin: '0 auto' }}>
      {emojiList.map((emojiSet) => (
        <ImageListItem
          key={`emogi${emojiSet.emojiValue}`}
          style={{
            textDecoration:
              emojiValue === emojiSet.emojiValue ? 'underline' : 'underline',
            fontWeight: emojiValue === emojiSet.emojiValue ? '700' : '700',
          }}
        >
          <emojiSet.emojiIcon
            className='emogi-list'
            // onClick={() => handleEmoji(emojiSet.emojiValue)}
            sx={{
              margin: '10px',
              fontSize: '4em',
              background: emojiSet.colorSet,
              // emojiValue === emojiSet.emojiValue
              //   ? emojiSet.colorSet
              //   : emojiSet.colorUnSet,
              border: 'none',
              // emojiValue === emojiSet.emojiValue
              //   ? `1px solid ${emojiSet.colorSet}`
              //   : `1px solid ${emojiSet.colorUnSet}`,
              borderRadius: '50px',
              // cursor: 'pointer',
            }}
          />
          <ImageListItemBar
            position='below'
            title={`${emojiSet.title}`}
            sx={{ margin: '0 auto' }}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

export default JobCardSatisfaction;

const emojiList = [
  {
    emojiValue: '1',
    emojiIcon: SentimentVeryDissatisfiedOutlinedIcon,
    colorUnSet: '#ff110055',
    colorSet: '#ff1100ff',
    title: 'Very Poor',
  },
  {
    emojiValue: '2',
    emojiIcon: SentimentDissatisfiedOutlinedIcon,
    colorUnSet: '#ff660055',
    colorSet: '#ff6600ff',
    title: 'Poor',
  },
  {
    emojiValue: '3',
    emojiIcon: SentimentNeutralOutlinedIcon,
    colorUnSet: '#ffff0055',
    colorSet: '#ffff00ff',
    title: 'Avarage',
  },
  {
    emojiValue: '4',
    emojiIcon: SentimentSatisfiedOutlinedIcon,
    colorUnSet: '#00ff0055',
    colorSet: '#00ff00ff',
    title: 'Good',
  },
  {
    emojiValue: '5',
    emojiIcon: SentimentVerySatisfiedOutlinedIcon,
    colorUnSet: '#22cc0055',
    colorSet: '#22cc00ff',
    title: 'Excelent',
  },
];
